import type { ResourceConfig } from '../interfaces/ResourceConfig';
import { DEFAULT_LOGGING_CONFIG } from './DEFAULT_LOGGING_CONFIG';
import { DEFAULT_REPORTING_CONFIG } from './DEFAULT_REPORTING_CONFIG';

/**
 * @group Constants
 * 
 * @summary
 * <blockquote>Default resource configuration for auth HOCs</blockquote>
 * 
 * @remarks
 * Centralized configuration for default logging and reporting settings used by auth HOCs.
 * Modify these values to change default behavior across all auth-protected resources.
 * 
 * @example
 * ```typescript
 * // To change default logging behavior
 * DEFAULT_RESOURCE_CONFIG.logs.development = false;
 * 
 * // To change default reporting behavior
 * DEFAULT_RESOURCE_CONFIG.reporting.samplingRate = 0.05;
 * 
 * // To change console reporting settings
 * DEFAULT_RESOURCE_CONFIG.reporting.consoleLevel = 'DEBUG';
 * DEFAULT_RESOURCE_CONFIG.reporting.consoleFormat = 'TEXT';
 * ```
 */
export const /**
 * @internal
 */
DEFAULT_RESOURCE_CONFIG: Omit<ResourceConfig, 'auth'> = {
  logs: DEFAULT_LOGGING_CONFIG,
  reporting: DEFAULT_REPORTING_CONFIG,
};